if (!customElements.get("configurator-main")) {
  class ConfiguratorMain extends HTMLElement {
    constructor() {
      super();

      /** @type ConfiguratorProducts */
      this.products = {};

      this.variantsJSON = {};
      this.pricesJSON = {};

      this.activeVariants = {};
    }

    /**
     * @param {Event} event
     */
    updateLenghtInputValue(event) {
      const target = /** @type {HTMLInputElement} target */ event.target;
      if (!(target instanceof HTMLInputElement)) return;
      const value = Number(target.value);

      const min = Number(target.getAttribute("min"));
      const max = Number(target.getAttribute("max"));

      if (!value || !min || !max) return;

      // @ts-ignore
      if (value > max) return (target.value = max);
      // @ts-ignore
      if (value < min) return (target.value = min);
    }

    /**
     * @param {Event} event
     */
    handleLengthChange(event) {
      this.updateLenghtInputValue(event);
      this.addLengthProduct();
    }

    /**
     * Filters and disables invalid options based on current selection.
     * @param {string} productId
     * @param {string} currentPosition
     */
    filterNextOptions(productId, currentPosition) {
      const currentSelections = this.products[productId] || {};
      // @ts-ignore
      const variants = this.variantsJSON[productId] || [];

      const optionInputs = this.querySelectorAll(
        `[data-product-id="${productId}"]`
      );

      optionInputs.forEach((input) => {
        const position = input.getAttribute("data-position");
        // @ts-ignore
        const value = input.value;

        if (!position || position <= currentPosition) return;

        // @ts-ignore
        const isValid = variants.some((variant) => {
          // Clone the current selection and add the candidate value for this position
          const testSelection = {
            ...currentSelections,
            [position]: value,
          };

          // Check if the variant matches all selected options including this one
          return Object.entries(testSelection).every(
            ([key, val]) => variant[`option${key}`] === val
          ) && variant.available;
        });

        // @ts-ignore
        input.disabled = !isValid;

        // @ts-ignore
        if (!isValid && input.checked) {
          // @ts-ignore
          input.checked = false;
          // @ts-ignore
          delete this.products[productId][position];

          document.dispatchEvent(
            new CustomEvent("summary:remove", {
              detail: {
                productId,
                position,
              },
            })
          );
        }
      });
    }

    /**
     * @param {String} productId 
     * @param {Number} position 
     */
    deselectOption(productId, position) {
      // @ts-ignore
      const value = this.products[productId][position];
      if(!value) return;

      const radio = this.querySelector(`[value="${CSS.escape(value)}"]`);
      if(!radio) return;

      // @ts-ignore
      radio.checked = false;
      radio.dispatchEvent(new Event('change'));

      // @ts-ignore
      delete this.products[productId][position]
    }

    /**
     * @param {Event} event
     */
    handleChange(event) {
      const target = /** @type {HTMLInputElement} */ event.target;
      if (!(target instanceof HTMLInputElement)) {
        return;
      }

      const productId = target.getAttribute("data-product-id");
      if (!productId) return;

      const position = target.getAttribute("data-position");
      if (!position) return;

      document.dispatchEvent(
        new CustomEvent("summary:update", {
          detail: {
            text: `${target?.getAttribute("data-summary")} <span>${
              target.value
            }</span>`,
            productId,
            position,
          },
        })
      );

      this.products[productId] = {
        ...this.products[productId],
        [position]: target.value,
      };

      const singleVariantId = target.getAttribute("data-variant-id");
      let variant = null;

      if (singleVariantId) {
        // @ts-ignore
        variant = Object.entries(this.variantsJSON[productId]).find(
          ([key, v]) => v.id == singleVariantId
        )[1];
      } else {
        if(Number(position) <= 2 && this.products[productId]) {
          // console.log(position);
          // console.log(this.products[productId]);
          
          // Deselect the next options
          this.deselectOption(productId, Number(position) + 1);
          this.deselectOption(productId, Number(position) + 2);
        } 
        this.filterNextOptions(productId, position);

        // @ts-ignore
        variant = this.findMatchingVariant(
          this.variantsJSON,
          this.products[productId],
          productId
        );
      }
      if (!variant) return;

      // @ts-ignore
      this.activeVariants[productId] = variant;

      // @ts-ignore
      const price = this.pricesJSON[productId][variant.id];
      if (!price) return;

      this.submitButton?.removeAttribute("disabled");

      document.dispatchEvent(
        new CustomEvent("configurator-image:change", {
          detail: {
            url:
              price.meta_image_variant ??
              price.meta_image ??
              price.variant_image,
            location: price.visualization_position,
            productId,
            height: price.meta_image_height_variant,
            offset: price.visualization_offset,
            scale: price.visualization_scale,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent("configurator-price:update", {
          detail: { productId, price: price.price_single },
        })
      );
    }

    /**
     * Finds the matching variant for a given productId and selected options.
     * @param {Object} variantsMap - A map of productId -> array of variants
     * @param {Object} selectedOptions - A map of productId -> { [position]: value }
     * @param {String} productId
     * @returns {Object|null} - The matched variant or null
     */
    findMatchingVariant(variantsMap, selectedOptions, productId) {
      const selected = selectedOptions;
      // @ts-ignore
      const variants = variantsMap[productId];
      if (!variants || !selected) return null;

      const selectedKeys = Object.keys(selected);
      const selectedCount = selectedKeys.length;

      return (
        // @ts-ignore
        variants.find((variant) => {
          const variantOptions = [
            variant.option1,
            variant.option2,
            variant.option3,
          ].filter(Boolean);
          if (variantOptions.length !== selectedCount) return false;

          for (let i = 0; i < selectedCount; i++) {
            const key = (i + 1).toString();

            // @ts-ignore
            if (variantOptions[i] !== selected[key]) {
              return false;
            }
          }

          return true;
        }) || null
      );
    }

    addLengthProduct() {
      this.lengthInput = this.querySelector("[js-length-input]");

      if (!this.lengthInput) return;

      this.lengthInputId = this.lengthInput.getAttribute("js-length-input");
      // @ts-ignore
      this.lengthValue = Number(this.lengthInput.value);

      // @ts-ignore
      const variants = this.variantsJSON[this.lengthInputId];

      // @ts-ignore
      const variant = variants.find((item) => {
        const [start, end] = item.options[0].split("-").map(Number);
        // @ts-ignore
        return this.lengthValue >= start && this.lengthValue <= end;
      });

      if (!variant) return;
      variant.isLength = true;
      // @ts-ignore
      this.activeVariants[this.lengthInputId] = variant;

      // @ts-ignore
      const price = this.pricesJSON[this.lengthInputId][variant.id];

      document.dispatchEvent(
        new CustomEvent("summary:update", {
          detail: {
            text: `${this.lengthInput?.getAttribute("data-summary")} <span>${
              this.lengthValue
            }</span>`,
            productId: this.lengthInputId,
            position: "Length",
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent("configurator-price:update", {
          detail: { productId: this.lengthInputId, price: price.price_single },
        })
      );

      document.dispatchEvent(
        new CustomEvent("configurator-length:update", {
          detail: {
            length: this.lengthValue,
            unit: this.lengthInput.getAttribute("data-unit"),
          },
        })
      );
    }

    handleSubmit() {
      // @ts-ignore
      const quantity = this.querySelector('[name="quantity"]')?.value || 1;

      const cartNote =
        // @ts-ignore
        `${this.querySelector('[name="note"]')?.value || ""}`;

      const timestamp = Date.now().toString();

      const items = Object.values(this.activeVariants).map((variant) => {
        const properties = {
          uniqueId: timestamp,
        };

        if (variant.isLength) {
          // @ts-ignore
          properties["Length"] = this.lengthValue;
        }

        return {
          id: variant.id,
          quantity: quantity,
          properties: properties,
        };
      });

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items }),
      })
        .then((res) => res.json())
        .then((data) => {
          const cartItems = document.querySelector("cart-items-component");

          const sectionId = cartItems?.getAttribute("data-section-id");

          return fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ note: cartNote, sections: [sectionId] }),
          })
            .then((res) => res.json())
            .then((data) => {
              if (!cartItems || !(cartItems instanceof HTMLElement)) return;
              // @ts-ignore
              const html = new DOMParser().parseFromString(
                // @ts-ignore
                data.sections[sectionId],
                "text/html"
              );
              const newCartItems = html.querySelector("cart-items-component");

              if (!newCartItems || !(newCartItems instanceof HTMLElement))
                return;
              cartItems.innerHTML = newCartItems?.innerHTML;

              const currentCartIcon = document.querySelector("cart-icon");
              const newCartIcon = html.querySelector("cart-icon");

              if (
                !currentCartIcon ||
                !(currentCartIcon instanceof HTMLElement) ||
                !newCartIcon ||
                !(newCartIcon instanceof HTMLElement)
              )
                return;

              currentCartIcon.innerHTML = newCartIcon.innerHTML;

              const cartDrawer = document.querySelector(
                "cart-drawer-component"
              );
              if (!cartDrawer) return;

              const currentDialog = cartDrawer.querySelector("dialog");

              // @ts-ignore
              cartDrawer?.open();

              // @ts-ignore
              currentDialog.classList.remove("cart-drawer--empty");
            });
        })
        .catch(console.error);
    }

    connectedCallback() {
      this.addEventListener("change", this.handleChange.bind(this));

      this.addEventListener("input", this.handleLengthChange.bind(this));

      this.querySelectorAll("[data-variants-json]").forEach((element) => {
        // @ts-ignore
        this.variantsJSON[element.getAttribute("data-variants-json")] =
          JSON.parse(element.innerHTML);
      });

      this.querySelectorAll("[data-variants-json]").forEach((element) => {
        // @ts-ignore
        this.variantsJSON[element.getAttribute("data-variants-json")] =
          JSON.parse(element.innerHTML);
      });

      this.querySelectorAll("[data-variants-prices]").forEach((element) => {
        // @ts-ignore
        this.pricesJSON[element.getAttribute("data-variants-prices")] =
          JSON.parse(element.innerHTML);
      });

      const defaultProductVariant = this.querySelector("[js-check-by-default]");
      if (defaultProductVariant) {
        // @ts-ignore
        defaultProductVariant.checked = true;
        defaultProductVariant.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      }

      this.submitButton = this.querySelector("[js-add]");
      if (this.submitButton)
        this.submitButton.addEventListener(
          "click",
          this.handleSubmit.bind(this)
        );

      this.addLengthProduct();
    }
  }

  customElements.define("configurator-main", ConfiguratorMain);
}
